// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js"}[chunkId] + "-" + {"532":"91f2e4d4e1d55aaf6d22","678":"34be44d044d692e6865e"}[chunkId] + ".js";
};